module.exports = __webpack_public_path__ + "img/ctrl-magic-dagger-stub--.11c44304.svg";